<style lang="stylus">  
  @import '../theme/variables.styl'

  .atuacaoBtn 
    color: $blue  
  
  h1
    color: $orange
    font-size: 60px
  
  .v-label  
    color: white !important

  .btn-cursor {
    cursor: pointer;
  }

  .btn-querotransformacao {
    cursor: pointer;
    border: #073A56 solid 6px;
    padding: 20px;
    text-align: center
  }

  #imgAtuacao
    width: calc(40vw)
    padding: 5px 40px 20px 20px        

  @media only screen and (max-width: 950px) {
    .atuacao-container {
      padding: 30px;
    }
    #imgAtuacao {
      width: calc(100vw);
      margin-left: -50px;
      padding: 0px;
    }
  }

  .v-text-field__slot > input, .v-text-field__slot > textarea {
    color: white !important;
    font-weight: 900 !important;
  }
</style>
<template>   
    <div>
      
      <!-- height -->
      <v-img height="calc(100vh - 0px)" src="static/bg.png" aspect-ratio="1.0"></v-img>
            
      <v-content>
         <v-snackbar v-model="snackbar" :timeout="snackbarTimeout" :top="true">
          {{ snackbarText }}        
          <v-btn color="pink" flat @click="snackbar = false">
            Fechar
          </v-btn>
        </v-snackbar>
        <section id="quemsomos">
          <v-layout column wrap class="my-5" align-center>          
            <v-flex xs12>
              <v-container grid-list-xl>
                <v-layout row wrap align-center>
                  <v-flex xs12 md4>
                    <v-card class="elevation-0 transparent">
                      <v-img src="static/quemsomos.png" aspect-ratio="1.2"></v-img>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 md8>
                    <v-card class="elevation-0 transparent">                    
                      <v-card-text>
                        A Beyond Cloud é uma empresa com grande expertise em Inteligência Artificial,
                        atuando em empresas com uma proposta de Transformação Digital. Nossa essência é entender
                        o cenário do cliente e realizar um projeto que pode envolver a <b>migração de processos para a nuvem</b>, assim como incluir
                        o desenvolvimento de soluções, sendo estas <b>aplicativos, integrações ou automações,</b> que venham a facilitar a rotina da empresa.
                      </v-card-text>
                    </v-card>
                  </v-flex>                
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </section>

        <section id="atuacao">
          <v-container>
            <v-layout row wrap align-center>
              <v-flex xs12 md4>
                <v-img src="static/atuacao.png" aspect-ratio="1.0"></v-img>
              </v-flex> 
              <v-flex xs12 md8>
                <v-container class="atuacao-container" grid-list-xl>
                  <v-layout row wrap align-center>                                   
                    <v-flex xs12>       
                      <v-img id="imgAtuacao" class="white--text" src="static/paper.png">
                        <v-atuacao></v-atuacao>                        
                      </v-img>
                    </v-flex>                
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </section>

        <section id="transformacaodigital">
          <v-transformacaodigital></v-transformacaodigital>
        </section>

        <section id="querotransformacao">
          <br><br><br>
          <v-layout column wrap align-center>
            <v-flex class="btn-querotransformacao" @click="openUrl('https://docs.google.com/forms/d/e/1FAIpQLSdRduh6aJaUI0zh_u1gS21AD4A3R6FecgNOQgB9SOK9wbkZAQ/viewform?usp=sf_link')" xs12 align-center>
              <h2> QUERO </h2>
              <h2> TRANSFORMAÇÃO </h2>            
            </v-flex>          
          </v-layout>
          <br><br><br><br>
        </section>

        <section id="contato">
          <v-container grid-list-xl>
            <v-layout row wrap justify-center class="my-5">
              <v-flex xs12 sm8 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-title primary-title class="layout justify-left">
                    <div class="headline headfooter">CONTATO</div>
                  </v-card-title>
                  <br>
                  <v-layout column wrap>
                    <v-flex xs12 sm12 md12>
                      <v-text-field v-model="name" outline color="white" background-color="white" label="Seu nome"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field v-model="mail" outline color="white" background-color="white" label="Seu email"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field v-model="subject" outline color="white" background-color="white" label="Seu assunto"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-textarea v-model="message" outline color="white" background-color="white" label="Sua mensagem"></v-textarea>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-btn @click="sendMessage" large outline color="white">Enviar</v-btn>
                    </v-flex>  
                  </v-layout>              
                </v-card>
              </v-flex>
              <v-flex xs12 sm8 md4 offset-md1>
                <v-card class="elevation-0 transparent">
                  <v-card-title primary-title class="layout justify-left">
                    <!-- <div class="headline headfooter">CONTATO</div> -->
                    <div class="headline headfooter">&nbsp;</div>
                  </v-card-title>                            
                  <br>
                  <v-list class="transparent">
                    <v-list-tile>
                      <v-list-tile-action >
                        <v-icon class="contact-icon">phone</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title class="contact-text">+55 81 3204-7240</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <br>
                    <v-list-tile class="btn-cursor" @click="openUrl('https://goo.gl/maps/jwx5GEDBMZq')">
                      <v-list-tile-action>
                        <v-icon class="contact-icon">place</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title class="contact-text">General Polidoro, 714</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <br>
                    <v-list-tile class="btn-cursor" @click="openUrl('https://fb.com/byndcloud')">
                      <v-list-tile-action>
                        <v-icon class="contact-icon">fab fa-facebook-f</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title class="contact-text">/byndcloud</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <br>
                    <v-list-tile class="btn-cursor" @click="openUrl('https://instagram.com/beyond.cloud')">
                      <v-list-tile-action>                      
                        <v-icon class="contact-icon">fab fa-instagram</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title class="contact-text">@beyond.cloud</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <br>
                    <v-list-tile>
                      <v-list-tile-action>                    
                        <v-icon class="contact-icon">email</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title class="contact-text">contato@beyondcloud.com.br</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card>
                
              </v-flex>
              
            </v-layout>
            
          </v-container>        
        </section>

        <div class="blueline">      
        </div>

        <v-footer class="primary" style="margin-top: -1px">
          <v-layout row wrap text-xs-right>
            <v-flex xs12>
              <div class="white--text ml-3" style="padding-right: 10px;">
                Beyond Cloud 2019 @ all rights reserved
              </div>
            </v-flex>
          </v-layout>
        </v-footer>
      </v-content>  
    </div>
</template>

<script>
import Atuacao from '@/components/Atuacao.vue';
import TransformacaoDigital from '@/components/TransformacaoDigital.vue';

export default {  
  components: {
    'v-atuacao': Atuacao,
    'v-transformacaodigital': TransformacaoDigital
  },
  data: () => ({
    snackbar: false,
    snackbarTimeout: 6000,
    snackbarText: 'Mensagem enviada',
    offsetTop: 0,
    name: '',
    mail: '',
    subject: '',
    message: ''
  }),

  computed: {

  },

  methods: {    
    changeContent (e) {
      console.log('a');
    },
    openUrl (url) {
      // console.log('do you want transformation?');
      window.open(url, '_blank');
    },
    sendMessage () {
      const url = 'https://script.google.com/macros/s/AKfycbxcJy-UffiW_21MSgemeF0A198ofKQq6rJxIFYnL4y6jK5sW8o/exec?' +
        'name=' + this.name +
        '&mail=' + this.mail +
        '&subject=' + this.subject +
        '&message=' + this.message;
      console.log(url);
      const data = Object.assign({}, {
        name: this.name,
        mail: this.mail,
        subject: this.subject,
        message: this.message
      });
      console.log(data);
      console.log(' -- result requests: ');
      fetch(url, {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded'
        }),
        mode: 'cors',
        cache: 'default',
        // body: data
      }).then((res) => {  
        console.log(res);
        this.snackbar = true;
      }).catch((err) => {
        console.error(err);
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Landing.vue